/** Confirmation dialog shown when a learner attempts to leave an active study session. */
import { Dialog, Button } from '@/interfaces/learner/ui';

interface AbandonSessionDialogProps {
  open: boolean;
  onClose: () => void;
  onAbandon: () => void;
  isPending: boolean;
  sessionType: 'learn' | 'revise';
  sessionTitle?: string | null;
}

/**
 * Single source of truth for the "active session in progress" abandon dialog.
 * Used by the session guard (pre-navigation) and session pages (direct URL fallback).
 */
export function AbandonSessionDialog({
  open,
  onClose,
  onAbandon,
  isPending,
  sessionType,
  sessionTitle,
}: AbandonSessionDialogProps) {
  const typeLabel = sessionType === 'revise' ? 'revision' : 'lesson';

  return (
    <Dialog isOpen={open} onClose={onClose} title="Active Session In Progress" size="sm">
      <p
        style={{
          fontSize: 14,
          color: 'var(--color-text-muted)',
          lineHeight: 1.6,
          marginBottom: 20,
        }}
      >
        You have an active {typeLabel} session
        {sessionTitle ? ` "${sessionTitle}"` : ''}. Starting a new session will abandon it.
      </p>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
        <Button variant="secondary" size="sm" onPress={onClose}>
          Cancel
        </Button>
        <Button variant="danger" size="sm" onPress={onAbandon} isDisabled={isPending}>
          {isPending ? 'Abandoning...' : 'Abandon & Start New'}
        </Button>
      </div>
    </Dialog>
  );
}
